export const PLAY_AUDIO_TEXT = {
    id: 'oe.uploadedAudio.play',
    description: 'Accessible label of the audio play button',
    defaultMessage: 'Play audio'
};
